import {BrandPreview} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/brand_preview.types';
import {LocationType, useInitialLocation} from '@aboutyou/router';
import {BrandPreviewEntity} from '../../BrandHub/utils/isBrandPreviewEntities';

export const useBrandLocationWithState = ({
  path,
  brandPreview,
}: {
  path: string;

  brandPreview?: BrandPreview;
}) => {
  const {host, protocol} = useInitialLocation();
  const {pathname, search} = new URL(path, `${protocol}://${host}`);

  return {
    pathname,
    search,
    ...(brandPreview && {
      state: {
        entities: {brandPreview} as BrandPreviewEntity,
      },
    }),
  } as LocationType;
};
